import { render, staticRenderFns } from "./Slips.vue?vue&type=template&id=48c7cbdc&scoped=true"
import script from "./Slips.vue?vue&type=script&lang=js"
export * from "./Slips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c7cbdc",
  null
  
)

export default component.exports